var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseInput',_vm._b({attrs:{"value":_vm.value.value,"clearable":_vm.clearable},on:{"input":_vm.input},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},'BaseInput',_vm.forbind,false))
}
var staticRenderFns = []

export { render, staticRenderFns }